export const SOCIALICONS = [
  {
    url: "https://www.linkedin.com/in/paargav-shanker-b6708a194/",
    network: "linkedin",
  },
  {
    url: "https://github.com/paarshan4800",
    network: "github",
  },
  {
    url: "https://mail.google.com/mail/u/0/?fs=1&to=paarshan4800@gmail.com&su=Contacting+after+seeing+Portfolio&tf=cm",
    network: "email",
  },
  {
    url: "https://www.instagram.com/paar_shan4800/",
    network: "instagram",
  },
  {
    url: "https://twitter.com/paarshan4800",
    network: "twitter",
  },
  {
    url: "https://www.facebook.com/paargav.shuttle",
    network: "facebook",
  },
];
